"use strict";

exports.__esModule = true;
exports.default = void 0;

var _LayoutObject = _interopRequireDefault(require("./LayoutObject"));

var _LayoutArray = _interopRequireDefault(require("./LayoutArray"));

var _LayoutList = _interopRequireDefault(require("./LayoutList"));

var _LayoutField = _interopRequireDefault(require("./LayoutField"));

var _LayoutFieldset = _interopRequireDefault(require("./LayoutFieldset"));

var _LayoutFormat = _interopRequireDefault(require("./LayoutFormat"));

var _LayoutThumbnail = _interopRequireDefault(require("./LayoutThumbnail"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import LayoutGrid from "./LayoutGrid"
var _default = {
  "fieldtypes": {},
  "fields": {},
  "layouts": {
    "object": _LayoutObject.default,
    "array": _LayoutArray.default,
    "list": _LayoutList.default,
    "format": _LayoutFormat.default,
    "field": _LayoutField.default,
    "fieldset": _LayoutFieldset.default,
    "thumbnail": _LayoutThumbnail.default //        "grid": LayoutGrid,

  },
  "widgets": {}
};
exports.default = _default;
module.exports = exports.default;